import angular from "angular";
import template from "./admin-instructor-send-daily-agenda.html";
import AdminInstructorSendDailyAgendaController from "./admin-instructor-send-daily-agenda.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.instructors.view.dailyagenda", {
    url: "/:instructorId/view/daily-agenda",
    controller: AdminInstructorSendDailyAgendaController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.instructors.view.dailyagenda", [])
  .config(config)
  .controller(
    "AdminInstructorSendDailyAgendaController",
    AdminInstructorSendDailyAgendaController,
  );
